import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NxSpinnerComponent } from '@allianz/ng-aquila/spinner';

@Component({
  selector: 'lib-loader-overlay',
  imports: [NxSpinnerComponent],
  templateUrl: './loader-overlay.component.html',
  styleUrl: './loader-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderOverlayComponent {
  loading = input<boolean>(false);
}
